import { addGroup, removeGroup } from "../operations/grouping/structure";
import { setOpenByRange } from "../operations/grouping/visibility";
import { resolveGroups, mapGroups } from "../operations/grouping/helpers";

export function addColumnGroup(column, page) {
	addGroup(this, "column", column, page);
}

export function removeColumnGroup(column, page) {
	removeGroup(this, "column", column, page);
}

export function addRowGroup(row, page) {
	addGroup(this, "row", row, page);
}

export function removeRowGroup(row, page) {
	removeGroup(this, "row", row, page);
}

export function openColumnGroup(column, page) {
	setOpenByRange(this, "column", column, true, page);
}

export function closeColumnGroup(column, page) {
	setOpenByRange(this, "column", column, false, page);
}

export function openRowGroup(row, page) {
	setOpenByRange(this, "row", row, true, page);
}

export function closeRowGroup(row, page) {
	setOpenByRange(this, "row", row, false, page);
}

export function getColumnGroups(page) {
	return mapGroups(resolveGroups(this, "column", page));
}

export function getRowGroups(page) {
	return mapGroups(resolveGroups(this, "row", page));
}
